// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProProfileContent_wrapper__e85EA"};